import { z } from "zod";
import { sessionStatusSchema } from "./sessions.js";
export const twinSessionOwnerSchema = z.object({
    id: z.string().trim().min(1),
    displayName: z.string().trim().min(1).max(200).optional(),
    avatarUrl: z.string().url().optional(),
}).strict();
export const twinSessionSummarySchema = z.object({
    id: z.string().trim().min(1),
    title: z.string().trim().min(1),
    owner: twinSessionOwnerSchema,
    status: sessionStatusSchema,
    channelId: z.string().trim().min(1).optional(),
    createdAt: z.number(),
    updatedAt: z.number(),
    startedAt: z.number().optional(),
    finishedAt: z.number().optional(),
}).strict();
